import * as React from 'react';

import { useQuery } from '@apollo/client';

import { get as userGet } from 'js/lib/user';

import AdminSelectedPartnerSlugContext from 'bundles/composable-page-header-admin/contexts/AdminSelectedPartnerSlugContext';
import AdminSelectedPartnerSlugQuery from 'bundles/composable-page-header-admin/queries/AdminSelectedPartnerSlugQuery.graphql';
import type {
  AdminSelectedPartnerSlugQuery as AdminSelectedPartnerSlugQueryType,
  AdminSelectedPartnerSlugQueryVariables,
} from 'bundles/composable-page-header-admin/queries/__generated__/AdminSelectedPartnerSlugQuery';

const AdminSelectedPartnerSlugProvider = ({ children }: { children: React.ReactNode }) => {
  const { id: userId } = userGet();

  const { data, error } = useQuery<AdminSelectedPartnerSlugQueryType, AdminSelectedPartnerSlugQueryVariables>(
    AdminSelectedPartnerSlugQuery,
    {
      context: {
        clientName: 'gatewayGql',
      },
      errorPolicy: 'all',
      skip: !userId,
    }
  );

  return (
    <AdminSelectedPartnerSlugContext.Provider
      value={{
        adminSelectedPartnerSlug: data,
        error,
      }}
    >
      {children}
    </AdminSelectedPartnerSlugContext.Provider>
  );
};

export default AdminSelectedPartnerSlugProvider;
